import type { Point } from './model';
export const defaultArea = { name: 'Stuttgart', center: [48.782, 9.187] as Point, radiusKm: 15 };
export const regionPresets: { name: string; center: Point; radiusKm: number }[] = [
  defaultArea,
  { name: 'Berlin', center: [52.52, 13.405], radiusKm: 20 },
  { name: 'Hamburg', center: [53.551, 9.994], radiusKm: 20 },
  { name: 'München', center: [48.137, 11.576], radiusKm: 20 },
  { name: 'Köln', center: [50.938, 6.96], radiusKm: 20 },
  { name: 'Frankfurt am Main', center: [50.11, 8.682], radiusKm: 20 },
  { name: 'Düsseldorf', center: [51.227, 6.773], radiusKm: 20 },
  { name: 'Hannover', center: [52.375, 9.733], radiusKm: 20 },
  { name: 'Bremen', center: [53.079, 8.801], radiusKm: 20 },
  { name: 'Dresden', center: [51.05, 13.738], radiusKm: 20 },
  { name: 'Leipzig', center: [51.34, 12.374], radiusKm: 20 },
  { name: 'Dortmund', center: [51.514, 7.465], radiusKm: 20 },
  { name: 'Essen', center: [51.456, 7.012], radiusKm: 20 },
  { name: 'Nürnberg', center: [49.453, 11.077], radiusKm: 20 },
  { name: 'Kiel', center: [54.323, 10.139], radiusKm: 20 },
  { name: 'Schwerin', center: [53.629, 11.414], radiusKm: 20 },
  { name: 'Potsdam', center: [52.4, 13.06], radiusKm: 20 },
  { name: 'Magdeburg', center: [52.12, 11.627], radiusKm: 20 },
  { name: 'Erfurt', center: [50.978, 11.029], radiusKm: 20 },
  { name: 'Wiesbaden', center: [50.083, 8.241], radiusKm: 20 },
  { name: 'Mainz', center: [50.0, 8.271], radiusKm: 20 },
  { name: 'Saarbrücken', center: [49.234, 6.997], radiusKm: 20 },
  { name: 'Freiburg', center: [47.999, 7.842], radiusKm: 20 },
  { name: 'Rostock', center: [54.092, 12.1], radiusKm: 20 },
  { name: 'Kassel', center: [51.312, 9.48], radiusKm: 20 },
  { name: 'Regensburg', center: [49.019, 12.097], radiusKm: 20 },
  { name: 'Aachen', center: [50.776, 6.084], radiusKm: 20 },
  { name: 'Lübeck', center: [53.866, 10.687], radiusKm: 20 },
  { name: 'Würzburg', center: [49.794, 9.93], radiusKm: 20 },
  { name: 'Flensburg', center: [54.784, 9.436], radiusKm: 20 },
  { name: 'Konstanz', center: [47.66, 9.175], radiusKm: 15 },
];
export function isGermanyPoint(p: Point) {
  return p[0] >= 47.2 && p[0] <= 55.2 && p[1] >= 5.8 && p[1] <= 15.2;
}
